import { z } from "zod";

import {
  PrintExamInput,
  PrintVerificationDocumentInput,
  PrintYearAtaGlanceInput,
  PrintPerformanceAssessmentInput,
} from "./schema";

import { IdentityContext } from ".";

export const IdentityContextInputSchema: z.Schema<IdentityContext> = z.object({
  appId: z.string(),
  userId: z.string(),
  workspaceId: z.string(),
  useSystemAdmin: z.boolean().optional(),
});

export const PrintExamInputSchema: z.Schema<PrintExamInput> = z.object({
  examId: z.string(),
  theme: z.string(),
  workspace: z.string(),
  copyrightYear: z.string(),
  date: z.string(),
  username: z.string(),
  coverPage: z.boolean().nullable().optional(),
  answerKey: z.boolean(),
  workspaceId: z.string(),
  dualColumn: z.boolean(),
  publisherName: z.string().nullable().optional(),
});

export const PrintVerificationDocumentInputSchema: z.Schema<PrintVerificationDocumentInput> =
  z.object({
    courseId: z.string(),
    username: z.string(),
    workspaceId: z.string(),
  });

export const PrintYearAtaGlanceInputSchema: z.Schema<PrintYearAtaGlanceInput> =
  z.object({
    courseId: z.string(),
    username: z.string(),
    workspaceId: z.string(),
    weeks: z.string().optional(),
    calendarId: z.string().optional(),
    showStandardsInGroups: z.boolean(),
    workspace: z.string(),
    copyrightYear: z.string(),
    date: z.string(),
  });

export const PrintPerformanceAssessmentInputSchema: z.Schema<PrintPerformanceAssessmentInput> =
  z.object({
    performanceAssessmentId: z.string(),
    username: z.string(),
    workspace: z.string(),
    copyrightYear: z.string(),
    date: z.string(),
    showStandards: z.boolean(),
  });
